import { createGlobalStyle } from 'styled-components';
import { ThemeType } from 'components/core/theme';
import 'styled-components';

const GlobalStyles = createGlobalStyle<{ theme: ThemeType }>`
  html {
      position: relative;
      min-height: 100vh;
  }
  body {
    background: #f4f4f4;
    color: ${({ theme }) => theme.palette.text.primary};
    font-family: 'Roboto', sans-serif;
    font-size: 1rem;
    margin: 0px;
    
  }`;

declare module 'styled-components' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  export interface DefaultTheme extends ThemeType {}
}

export const DoctorRootStyle = createGlobalStyle`
  html { font-size: 16px; }
`;

export const DSORootStyle = createGlobalStyle`
  html { font-size: 17px; }
  body {
    color: rgb(31, 41, 55);
  }
`;

export default GlobalStyles;
